import { fetchWrapper } from '../Helpers/fetchWrapper';
import { apiService } from './apiService';
import { stateMachineService } from './stateMachineService';

const CREATE_IMAGE_EVENTS = "CreateImageEvents";

const getEventsByAoiId = (aoiId) => {
    return fetchWrapper.get(`${apiService.getApiUrl()}/aoi/${aoiId}/events`);
};

const updateEvent = (eventId, eventData) => {
    return fetchWrapper.put(`${apiService.getApiUrl()}/event/${eventId}`, eventData);
};

const createEvent = (eventData) => {
    return fetchWrapper.post(`${apiService.getApiUrl()}/event`, eventData);
};

const deleteEvent = (eventId) => {
    return fetchWrapper.deleteRequest(`${apiService.getApiUrl()}/event/${eventId}`);
};

const getInteger = (value) => {
    const parsedValue = parseInt(value, 10);
    return Number.isNaN(parsedValue) ? 1000 : parsedValue;
};

const updateGeoJson = (eventGeoJsonId, name, geoJsonTypeId, sequenceNo, file) => {
    const formData  = new FormData();
    formData.append('name', name);
    formData.append('geoJsonTypeId', geoJsonTypeId);
    formData.append('sequenceNo', getInteger(sequenceNo));
    if(file != null)
        formData.append('file', file);

    return fetchWrapper.put(`${apiService.getApiUrl()}/eventgeojson/${eventGeoJsonId}`, formData, null, true);
};

const addGeoJson = (eventId, name, geoJsonTypeId, sequenceNo, file) => {
    const formData  = new FormData();
    formData.append('name', name);
    formData.append('geoJsonTypeId', geoJsonTypeId);
    formData.append('sequenceNo', getInteger(sequenceNo));
    formData.append('file', file);

    return fetchWrapper.post(`${apiService.getApiUrl()}/eventgeojson/${eventId}`, formData, null, true);
};

const addImage = (eventId, name, file, imagePath, maxx, maxy, minx, miny) => {
    const formData  = new FormData();
    formData.append('name', name);
    formData.append('file', file);
    formData.append('imagePath', imagePath);
    formData.append('maxx', maxx);
    formData.append('maxy', maxy);
    formData.append('minx', minx);
    formData.append('miny', miny);

    return fetchWrapper.post(`${apiService.getApiUrl()}/eventimage/${eventId}`, formData, null, true);
};

const updateImage = (eventImageId, name, file, imagePath, maxx, maxy, minx, miny) => {
    const formData  = new FormData();
    formData.append('name', name);
    formData.append('file', file);
    formData.append('imagePath', imagePath);
    formData.append('maxx', maxx);
    formData.append('maxy', maxy);
    formData.append('minx', minx);
    formData.append('miny', miny);

    return fetchWrapper.put(`${apiService.getApiUrl()}/eventimage/${eventImageId}`, formData, null, true);
};

const deleteGeoJson = (eventGeoJsonId) => {
    return fetchWrapper.deleteRequest(`${apiService.getApiUrl()}/eventgeojson/${eventGeoJsonId}`);
};

const deleteImage = (eventImageId) => {
    return fetchWrapper.deleteRequest(`${apiService.getApiUrl()}/eventimage/${eventImageId}`);
};

const createEventOld = (region, data) => {
    return stateMachineService.run(region, CREATE_IMAGE_EVENTS, data);
};

const getCreateEventStatus = (region, executionId) => {
    return stateMachineService.getStatus(region, CREATE_IMAGE_EVENTS, executionId);
};

const confirmBounds = (region, executionId, data) => {
    return stateMachineService.callback(region, CREATE_IMAGE_EVENTS, executionId, data);
};

const cancelCreateEvent = (region, executionId) => {
    return stateMachineService.stop(region, CREATE_IMAGE_EVENTS, executionId);
};

const deleteAllEvents = (region, member_aoi_id, usecase) => {
    return fetchWrapper.deleteRequest(`${apiService.getApiBaseUrl(region)}/event/aoi/${member_aoi_id}/${usecase}`);
};

const getTimelineR1 = (mkey, region, member_aoi_id) => {
    return fetchWrapper.get(`${apiService.getMemberApiBaseUrl(region)}/${mkey}/aoi/${member_aoi_id}/AoIRGBImageR1/events`);
};

const getAoiAnnotations = (member_aoi_id) => {
    return fetchWrapper.get(`${apiService.getApiBaseUrl("")}/aoi/annotations/${member_aoi_id}`);
}

const getAnnotations = (eventId) => {
    return fetchWrapper.get(`${apiService.getApiUrl()}/event/${eventId}/annotations`);
}

const createAnnotation = (annotation) => {
    return fetchWrapper.post(`${apiService.getApiUrl()}/annotation`, annotation);
}

const editAnnotation = (annotationId, annotation) => {
    return fetchWrapper.put(`${apiService.getApiUrl()}/annotation/${annotationId}`, annotation);
};

const deleteAnnotation = (annotationId) => {
    return fetchWrapper.deleteRequest(`${apiService.getApiUrl()}/annotation/${annotationId}`);
};

export const eventService = { 
    getEventsByAoiId,
    updateEvent,
    createEvent,
    getTimeline,
    getTimelineV2,
    getTimelineR1,
    getAnnotations,
    createAnnotation,
    editAnnotation,
    deleteAnnotation,
    deleteEvent,
    createEventOld,
    getCreateEventStatus,
    confirmBounds,
    cancelCreateEvent,
    deleteAllEvents,
    saveAnnotatedImage,
    getAoiAnnotations,
    addGeoJson,
    updateGeoJson,
    deleteGeoJson,
    addImage,
    updateImage,
    deleteImage
};

function getTimeline(mkey, region, member_aoi_id) {
    return fetchWrapper.get(`${apiService.getMemberApiBaseUrl(region)}/${mkey}/aoi/${member_aoi_id}/AoIRGBImage/events`);
}

function getTimelineV2(mkey, region, member_aoi_id){
    return fetchWrapper.get(`${apiService.getMemberApiBaseUrl(region)}/${mkey}/aoi/${member_aoi_id}/AoIRGBImageV2/events`);
}





function saveAnnotatedImage(url, image) {
    const headers={'Content-Type': 'image/png'};
    return fetchWrapper.put(url, image, headers);
}